module.exports = __webpack_public_path__ + "fonts/fa-light-300.a624ea3f.eot";